<template>
  <div
    class="access-code-input"
    :class="`variant-${variant}`"
  >
    <div>
      <div
        class="title-wrapper"
      >
        <h3>{{ props.title }}</h3>
      </div>
      <div class="text-base text-vp-base-900 py-1">
        <h4>{{ props.instructions }}</h4>
      </div>
    </div>
    <div class="flex flex-col">
      <div class="mx-auto my-auto w-full">
        <form class="flex flex-row">
          <input
            id="access-code"
            ref="codeInput"
            v-model="accessCode"
            type="text"
            :placeholder="props.placeholder"
            class="rounded-l-lg outline-none pl-4 h-10 w-full"
            autocomplete="off"
            autocapitalize="off"
            @keydown.enter.prevent="onApplyAccessCode"
          >
          <Accessible v-if="props.accessibleLabel">
            <label for="access-code">{{ props.accessibleLabel }}</label>
          </Accessible>
          <span class="input-btn-wrapper flex w-min items-center  rounded-r-lg p-1 px-2 font-bold">
            <VPButton
              class="apply-button block min-w-full max-h-9 px-4 !text-vp-base-100 !rounded-lg"
              :label="$gettext('Apply')"
              variant="text"
              theme="base-grey"
              size="sm"
              @click="onApplyAccessCode"
            />
          </span>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import VPButton from '@/components/form/VPButton.vue';
import Accessible from '@/components/Accessible.vue';
import { useGettext } from 'vue3-gettext';

const { $gettext } = useGettext();

type Props = {
  title: string;
  instructions: string;
  placeholder: string;
  accessibleLabel?: string;
  variant?: 'accessCode' | 'password';
};

const emit = defineEmits<{
  (e: 'apply', code: string): void;
}>();

const props = withDefaults(defineProps<Props>(), {
  variant: 'accessCode',
});

const accessCode = ref<string>('');
const codeInput = ref<HTMLInputElement | null>(null);

const onApplyAccessCode = () => emit('apply', accessCode.value);

onMounted(() => {
  if (props.variant === 'password') {
    codeInput.value?.focus();
  }
});
</script>
